module.exports = __webpack_public_path__ + "img/H02067-38.4fa137e1.jpg";